import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './CompanyRow.css';

class CompanyRow extends React.Component {
    render() {
	var company = this.props.company;
	var url = "http://" + company.url;

	if (company.description) {
	    return (
		<OverlayTrigger overlay={<Tooltip>{company.description}</Tooltip>}>
		    <tr>
			<td className="hasdescription"><span>{company.name}</span></td>
			<td>{company.address}</td>
			<td>{company.city}</td>
			<td>{company.tel}</td>
			<td><a href={url}>{company.url}</a></td>
			<td>{company.category}</td>
		    </tr>
		</OverlayTrigger>
	    );
	} else {
	    return (
		<tr>
		    <td>{company.name}</td>
		    <td>{company.address}</td>
		    <td>{company.city}</td>
		    <td>{company.tel}</td>
		    <td><a href={url}>{company.url}</a></td>
		    <td>{company.category}</td>
		</tr>
	    );
	};
    }
}

export default CompanyRow;
